<template>
  <div id="app">
    <!-- 提示页面 -->
    <app-tips 
    :tipInfo="tipInfo" 
    :btnshow="btnshow"
    :btnreload="btnreload"
    :btnpay="btnpay"
    :imei="imei"
    :order="order"
    @tipShow="tipShow" 
    @countinuePay="countinuePay"
    v-show="tipshow"></app-tips>

  <!-- 点击出货页面 -->
  <pay-page
    :order="order"
    :imei = "imei"
    :source="source"
    :showPayBtn="showPayBtn"
    @confirm="handleConfirm"
    @hideBtn = "hideBtn"
  ></pay-page>
  </div>
</template>

<script>
import payPage from './components/payPage/payPage'
import Tips from './components/tips/Tips'
export default {
  name: 'App',
  components:{
      "pay-page":payPage,
      "app-tips":Tips,
  },
  data(){
    return{
      order:'',
      putOrderInfo:{
            imei:"",
            order:"",
      },//提交的订单信息
      tipInfo:"",
      tipshow:false,
      btnshow:true,
      btnreload:false,
      btnpay:false,
      tipReload:false,//tips页面是否刷新页面
      commentNum:0,
      source:0,//入口  微信 WeiXIN  支付宝 Alipay
      machineId:"",//货机id
      imei:"",
      res:{},
      showPayBtn:true,
      checkPage: false,
      checkMessage: '',

    }
  },

  created(){
    //console.log(this)
    if(this.$route.query.order){
      this.order = this.$route.query.order
    }

    if(this.$route.query.imei){
        this.imei = this.$route.query.imei
    }
    console.log(this.order)
    console.log(this.imei)

    //识别扫描入口
    var ua = window.navigator.userAgent.toLowerCase();
    if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {  
          //判断是不是微信
          this.source = 1;
          

    } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
        //判断是不是支付宝
        this.source = 2;
        
    } else {
        //哪个都不是退出
        alert('请使用微信或支付宝扫码，谢谢！');
        this.tipInfo = "请使用微信或支付宝扫码，谢谢！";
        this.tipshow = true;
        this.btnshow = false;
        setTimeout(function(){
          window.opener=null;
          window.close();
        },3000)
        return ;
    }
  },
  methods: {
    hideBtn(){
      this.showPayBtn = false
    },
    showTip(info){
      //console.log(info)
      this.tipInfo = info
      this.tipshow = true
    },
    showMessage(info){
      this.tipInfo = info
      this.tipshow = true
      this.btnshow = false
    },
    tipShow(){
      this.tipshow = false
      if(this.tipReload){
        //刷新页面
        location.reload();
      }
    },
    countinuePay(){
      console.log('continuePay');
      this.tipshow = false;
      this.putOrderInfo.check = false;
      //this.handleConfirm();
    },

    handleChooseGoods: function(that){ //不带购物车的时候获取订单数据
      this.orderInfo = that
      console.log(this.orderInfo)
      //添加货道信息
      let info = {};
      let p_info = Array();
          p_info[0]='{"No":'+that['No']+',"count":1,"goods_id":'+that['goods_id']+',"price":'+that['price']+'}';
          // p_info[0]={
          //       "No":that['No'],
          //       "count":1,
          //       "goods_id":that['goods_id'],
          //       "price":that['price']
          //     };
      info['total_price'] = that['price'];
      info['total_count'] = 1;
      info['No_list'] = that['No'];
      info['machine_id'] = that['machine_id'];
      info['merchant_id'] = that['merchant_id'];
      info['operation_id'] = that['operation_id'];
      info['goods'] = p_info;
      info['goods_id'] = that['goods_id'];
      this.cartOrderInfo = info;
      //console.log(this.cartOrderInfo)

      this.multi_page = false
      this.order_page = true
    },
    handleConfirm: function(){
      //隐藏支付按钮
      this.showPayBtn = false
      //将信息插入orderInfo中
      this.putOrderInfo.order = this.order
      this.putOrderInfo.imei =  this.imei
      var url = "https://home.hrcc8.com/home/keyboard/out" //下单接口  
      //var url = "http://192.168.1.246/home/keyboard/out" //下单接口  
      //alert(url)
      this.axios.post(   //请求方式
      url,  //接口地址
      this.putOrderInfo
      )    //传递参数 
      .then(response =>{
          //if(response.data.code == 20000){
            console.log(response.data.msg)
            this.tipInfo = response.data.msg;
            this.tipshow = true;
          //}
      })
      .catch((error) => {
          console.log(error)
          //alert("非常抱歉，出现系统内部错误！")
          this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
          //this.tipInfo = error;
          this.tipshow = true;
          //显示支付按钮
          //this.showPayBtn = true
      })
    },
    handleBack:function(){
      this.order_page = false
      this.pay_page = false
      this.multi_page = true
      this.bsoll = true
      this.showPayBtn = true
    },
    fshowPayBtn: function(){
      this.showPayBtn = true
    },
  }
}
</script>

<style >
  body{
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue